import { render, staticRenderFns } from "./AnnouncementPostModal.vue?vue&type=template&id=51f441e8"
import script from "./AnnouncementPostModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementPostModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports